import { theme } from "../theme/theme";

/**
 * Standard chip height — matches the Pro badge on Local Jobs listing cards.
 * Use for every chip/badge across the app (listing, filter, profile, legend).
 */
export const LISTING_BADGE_HEIGHT = theme.sizes.listingBadgeHeight;

/** Fixed-height chip shell — spread into any chip style, then add backgroundColor. */
export const chipShell = {
  height: LISTING_BADGE_HEIGHT,
  minHeight: LISTING_BADGE_HEIGHT,
  maxHeight: LISTING_BADGE_HEIGHT,
  paddingVertical: 0,
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  flexShrink: 0,
  alignSelf: "flex-start",
};

export const listingBadge = {
  ...chipShell,
  borderRadius: 6,
  paddingHorizontal: 10,
};

/** Filter / select chips — same height, slightly rounder corners. */
export const filterChipShell = {
  ...chipShell,
  borderRadius: 8,
  paddingHorizontal: 8,
  alignSelf: "center",
};

export const listingBadgeText = {
  fontSize: 12,
  fontWeight: "700",
  color: "#FFFFFF",
  fontFamily: "Poppins",
  lineHeight: 14,
  includeFontPadding: false,
  textAlignVertical: "center",
};

export const listingBadgeVariant = (backgroundColor) => ({
  ...listingBadge,
  backgroundColor,
});

/** Outlined action chip — orange border/text, white bg (Profile Edit, My List Clear all, etc.) */
export const outlinedChipButton = {
  ...chipShell,
  backgroundColor: theme.colors.surface,
  borderWidth: 1,
  borderColor: theme.colors.primary,
  borderRadius: 6,
  paddingHorizontal: 10,
};

export const outlinedChipButtonText = {
  fontSize: 12,
  fontFamily: "Poppins",
  fontWeight: "600",
  color: theme.colors.primary,
};

/** Shared readable typography for category and location selection options. */
export const selectionOptionText = {
  fontSize: 16,
  lineHeight: 22,
  fontWeight: "500",
  fontFamily: "Poppins",
};

/** One chip for location pickers — 16 medium, 8px corners, outline until selected. */
export const locationPickChip = {
  ...filterChipShell,
  backgroundColor: theme.colors.surface,
  borderWidth: 1,
  borderColor: theme.colors.outline,
  paddingHorizontal: 10,
  marginRight: 0,
  marginBottom: 0,
};

export const locationPickChipSelected = {
  ...locationPickChip,
  backgroundColor: theme.colors.surface,
  borderColor: theme.colors.primary,
};

export const locationPickChipText = {
  ...selectionOptionText,
  color: theme.colors.onSurface,
  includeFontPadding: false,
  textAlignVertical: "center",
};

export const locationPickChipTextSelected = {
  ...locationPickChipText,
  color: theme.colors.primary,
};

/** Form tokens — outlined so they don't compete with the Add Locations button. */
export const locationPickChipOnForm = {
  ...locationPickChip,
  backgroundColor: theme.colors.surface,
  borderColor: theme.colors.primary,
};

export const locationPickChipOnFormText = {
  ...locationPickChipText,
  color: theme.colors.primary,
};
